import { Box, Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import { StyledImg } from '../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../elements/molecules/stack/Stack';

export function OsasEssIntro(props: { onClick: () => void }) {
    return (
        <CustomContainer>
            <Box
                backgroundColor="white"
                padding={8}
            >
                <Stack>
                    <Heading
                        as="h2"
                        size="xlarge"
                    >
                        Hoe slaperig ben je overdag?
                    </Heading>
                </Stack>

                <Stack>
                    <StyledImg
                        alt="ESS vragenlijst introductie"
                        src="/assets/images/somnology/questionnaires/ess-questionnaire-intro.svg"
                        srcSet="/assets/images/somnology/questionnaires/ess-questionnaire-intro.svg 1x, /assets/images/somnology/questionnaires/ess-questionnaire-intro.svg 2x, /assets/images/somnology/questionnaires/ess-questionnaire-intro.svg 3x,"
                    />
                </Stack>

                <Stack>
                    <Text>
                        De Slaperigheidstest (ESS, Epsworth Sleepiness Scale) bestaat uit 8 vragen om te kijken hoe
                        slaperig je bent en of je neiging hebt om in slaap te vallen. De vragen gaan over{' '}
                        <b>je huidige leefwijze.</b>
                    </Text>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.onClick}
                        variant="solid"
                        width="full-below-small"
                    >
                        Beantwoord vragen
                    </Button>
                </ButtonRow>
            </Box>
        </CustomContainer>
    );
}
